import React from "react";
import { ClientFactory } from "@/main/common/ClientFactory";
import type { PublishShortPostRequest } from "@/generated-client";
import type { Localizer } from "@/main/react/Types";
import { ShortPostForm } from "@/main/react/shortpost/ShortPostForm";

/**
 * The inline one-field box at the top of the Following tab (round 31 D10, A6). Signed-in members only;
 * the host (`HomeFeedList`) decides that. Create is unchanged: this is the short door, not a
 * replacement for the long one. Design: designs/00-inbox/2026-09-23-short-posts-and-idea-graph-design.md.
 */
export function ShortPostComposer(props: { localizer: Localizer }) {
    const { localizer } = props;
    const submit = React.useCallback(
        (request: PublishShortPostRequest) => ClientFactory.getAjaxDiscussionRestControllerApi().publishShortPost(request),
        [],
    );

    return (
        <ShortPostForm
            localizer={localizer}
            placeholder={localizer("short_post.composer.placeholder")}
            submitLabel={localizer("short_post.composer.submit")}
            submit={submit}
            navigationSource="short_post_composer"
            playwrightId="short-post-composer"
            offerFullPostOverLimit
            className="border-b border-divider px-4 py-3"
        />
    );
}
